<template>
  <modal :modal-key="'declined_request'" :class-style="'modal--welcomeback'"
         :body-style="'welcone_pad'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_declined_req_oh_no }}</h1>
      <p>{{ declineReason }}</p>
      <img class="pinicon" src="static/images/declined_challenge_icon.svg" alt="">
    </template>
    <template slot="body">
      <div class="new_game_buttons_section ">
        <h2>{{ getTranslations.home_declined_req_do_you_want }}</h2>
        <div class="btn_left"><p>{{ getTranslations.home_declined_req_random_game }}</p><a
          @click.prevent="playGameMethod" style="cursor:pointer"><img src="static/images/random_icon.svg" alt=""></a>
        </div>
        <div class="btn_right"><p>{{ getTranslations.home_declined_req_choose_another_friend }}
        </p><a @click.prevent="goToFavoritePage" style="cursor:pointer"><img src="static/images/friend_icon.svg" alt=""></a>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
// import { loading } from '@/common/jQuery';
import NewGameMixin from '@/common/mixins/home';

export default {
  // modal_declined_request.html
  name: 'generic-declined-request',
  mixins: [NewGameMixin],
  components: {
    Modal,
  },
  mounted() {
    // loading();
    // fix animation on window resize
    // eslint-disable-next-line
    // $(window).resize(() => loading());
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForChallenge',
    ]),
    goToFavoritePage() {
      this.$router.push('/home/favoriteUsers');
      this.storeModalForChallenge(null);
      this.storeModalForHomePage(null);
    },
    playGameMethod() {
      this.playGame();
      this.storeModalForChallenge(null);
      this.storeModalForHomePage(null);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('users', [
      'declineReason',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/DeclinedRequest.vue